import { Suspense, lazy } from "react";

import CircularLoader from "shared/components/atoms/CircularLoader";
import componentLoader from "shared/utils/componentLoader";

import { AuthModalHeaderTitleContainer } from "./styles";

const LexicalEditor = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkName: "LexicalEditor", filename: "LexicalEditor" */
        "@LexicalEditor/index"
      ),
  ),
);

interface IAuthModalHeaderTitleProps {
  title: string;
  description: string;
}
const AuthModalHeaderTitle = ({
  title,
  description,
}: IAuthModalHeaderTitleProps) => {
  return (
    <AuthModalHeaderTitleContainer>
      {title ? <h1 className="auth-modal-header-title">{title}</h1> : null}

      {!!description ? (
        <Suspense fallback={<CircularLoader />}>
          <LexicalEditor htmlContent={description} />
        </Suspense>
      ) : null}
    </AuthModalHeaderTitleContainer>
  );
};

export default AuthModalHeaderTitle;
